

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

export function LoadingSpinner({ size = 'md', text, className = '' }: LoadingSpinnerProps): JSX.Element {
  const getSpinnerClass = (size: string): string => {
    switch (size) {
      case 'sm':
        return 'spinner-border-sm';
      case 'lg':
        return 'spinner-border-lg';
      default:
        return '';
    }
  };

  const spinnerClass = `spinner-border ${getSpinnerClass(size)} ${className}`.trim();

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className={spinnerClass} role="status">
        <span className="sr-only">Loading...</span>
      </div>
      {text && (
        <span className="ml-2">{text}</span>
      )}
    </div>
  );
}